<template>
  <v-layout row justify-center>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="790"
      max-height="300"
      scrollable="true"
    >
      <v-card>
        <v-card-title class="headline"> {{ $t("Add-Line") }} </v-card-title>
        <v-card-text>
          <v-layout justify-center>
            <v-card width="780px" flat>
              <v-card-text>
                <v-card class="pa-2" flat>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    max-width="450px"
                    offset-x
                  >
                    <template v-slot:activator="{ on }">
                      <v-card>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap align-center pa-2>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field
                                    label="Satır Başlığı"
                                    v-model="LineTitle"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field
                                    v-model="RecieptExplain"
                                    label="Fiş Satır Açıklama"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm9 md9>
                                  <v-radio-group v-model="deptCredit" row>
                                    <v-radio
                                      label="Borç"
                                      :value="false"
                                    ></v-radio>
                                    <v-radio
                                      label="Alacak"
                                      :value="true"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                                <v-flex xs4 sm2 md2>
                                  <v-btn color="indigo" dark block v-on="on">
                                    {{ $t("Edit") }}
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex
                              xs12
                              sm3
                              md3
                              v-for="(chipText, ind) in resultList"
                              :key="ind"
                            >
                              <v-chip v-if="ind == 0" class="ma-1">
                                {{ chipText.text }}
                              </v-chip>
                              <v-chip v-if="ind > 0" class="ma-1">
                                <v-icon left :color="chipText.iconColor">{{
                                  chipText.iconName
                                }}</v-icon>
                                {{ chipText.text }}
                              </v-chip>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card>

                      <v-text-field
                        style="display: none"
                        v-model="result"
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <div
                            v-for="(chipText, index) in resultList"
                            :key="index"
                          >
                            <v-chip v-if="index == 0" class="ma-1">
                              {{ chipText.text }}
                            </v-chip>
                            <v-chip v-if="index > 0" class="ma-1">
                              <v-icon left :color="chipText.iconColor">{{
                                chipText.iconName
                              }}</v-icon>
                              {{ chipText.text }}
                            </v-chip>
                          </div>
                        </template>
                      </v-text-field>
                    </template>

                    <v-card>
                      <v-divider></v-divider>
                      <v-layout row wrap justify-end>
                        <v-btn flat @click="clearAll()">{{ $t('Clean') }}</v-btn>
                        <v-btn color="primary" flat @click="saveResult()"
                          >{{ $t("save_button") }}
                        </v-btn>
                      </v-layout>

                      <v-divider></v-divider>
                      <v-container
                        id="scroll-target"
                        style="max-height: 300px"
                        class="scroll-y ma-0 pa-0"
                      >
                        <v-layout
                          v-scroll:#scroll-target="onScroll"
                          column
                          style="height: 1000px"
                        >
                          <v-card
                            v-for="item in items"
                            :key="item.FieldID"
                            class="pa-1 ma-2 elevation-4 rounded-corner"
                          >
                            <v-layout row wrap align-center>
                              <v-flex xs12 sm10 md8 class="body-1">
                                {{ item.FieldName }}
                              </v-flex>
                              <v-flex xs12 sm10 md4>
                                <v-layout row wrap justify-space-between>
                                  <v-flex xs12 sm4 md4>
                                    <v-btn
                                      flat
                                      icon
                                      :disabled="item.selected"
                                      color="info"
                                      @click="pickData(1, item.FieldID)"
                                    >
                                      <v-icon>add</v-icon>
                                    </v-btn>
                                  </v-flex>
                                  <v-flex xs12 sm4 md4>
                                    <v-btn
                                      flat
                                      icon
                                      :disabled="item.selected"
                                      color="info"
                                      @click="pickData(2, item.FieldID)"
                                    >
                                      <v-icon>remove</v-icon>
                                    </v-btn>
                                  </v-flex>
                                  <v-flex
                                    xs12
                                    sm4
                                    md4
                                    @click="pickData(3, item.FieldID)"
                                  >
                                    <v-btn flat icon color="red">
                                      <v-icon>delete</v-icon>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-card>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-menu>
                </v-card>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">{{
            $t("cancel_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import auth from "@/api/auth";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
  props: {
    value: {},
    status: {},
    lineID: {},
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      LineTitle:null,
      RecieptExplain:null,
      deptCredit: false,
      update: false,
      offsetTop: 0,
      loadingvmodel: false,
      sendText: null,
      menu: false,
      resultList: [],
      result: null,
      selectedFieldId: 0,
      dialog: false,
      searchParams: {
        FieldID: 0,
        FieldName: null,
        FieldDBName: null,
        FieldDB: 1, // 1 : Bilet, 2: Cari, 3: Coper
        FieldTableName: null,
        TemplateType: 1,
      },
      items: [],
    };
  },
  methods: {
    setTemplateType(templateType) {
      this.searchParams.TemplateType = templateType;
    },
    openUpdateDialog(params) {
      this.resultList = [];
      this.items = [];
      this.$http
        .post(
          auth.API_URL +
            "api/AccountingIntegrations/IntegrationTemplateLineLoad",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            // eslint-disable-next-line no-useless-escape
            var separators = ["\\+", "-", "\\*", "\\?"];
            var tokens = response.body.LineScript.split(
              new RegExp(separators.join("|"), "g")
            );
            this.deptCredit = response.body.DeptCredit;
            this.RecieptExplain = response.body.RecieptExplain;
            this.LineTitle = response.body.LineTitle;
            this.getListforUpdate(tokens, response.body.LineScript);
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    },
    clearAll() {
      this.resultList = [];
      this.items.forEach((element) => {
        element.selected = false;
      });
    },
    saveResult() {
      this.sendText = null;
      this.resultList.forEach((element) => {
        if (element.iconName == "remove") {
          if (this.sendText == undefined) {
            this.sendText = element.text;
          } else {
            this.sendText = this.sendText + "-" + element.text;
          }
        } else {
          if (this.sendText == undefined) {
            this.sendText = element.text;
          } else {
            this.sendText = this.sendText + "+" + element.text;
          }
        }
      });

      var data = {
        text: this.sendText,
        deptCredit: this.deptCredit,
        RecieptExplain: this.RecieptExplain,
        LineTitle: this.LineTitle  
      };

      if (this.update) {
        this.$emit("updateResult", data);
      } else {
        this.$emit("saveResult", data);
      }

      this.dialog = false;
    },
    pickData(key, kod) {
      switch (key) {
        case 1:
          var fieldNameAdd = this.items.find((x) => x.FieldID == kod);
          fieldNameAdd.selected = true;
          var resultAdd = {
            iconColor: "green",
            iconName: "add",
            text: fieldNameAdd.FieldName,
            value: kod,
          };
          this.resultList.push(resultAdd);

          break;
        case 2:
          var fieldNameRemove = this.items.find((x) => x.FieldID == kod);
          fieldNameRemove.selected = true;
          var resultRemove = {
            iconColor: "red",
            iconName: "remove",
            text: fieldNameRemove.FieldName,
            value: kod,
          };
          this.resultList.push(resultRemove);
          break;
        case 3:
          var fieldIndex = this.resultList.findIndex((x) => x.value == kod);
          if (fieldIndex > -1) {
            var fieldAll = this.items.find((x) => x.FieldID == kod);
            fieldAll.selected = false;
            this.resultList.splice(fieldIndex, 1);
          }

          break;
        default:
          break;
      }
    },
    openDialog() {
      this.update = false;
      this.loadingvmodel = true;
      this.items = [];
      this.resultList = [];
      this.getList();
    },
    getListforUpdate(value, list) {
      this.update = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationFieldList",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            response.body.forEach((element) => {
              var newElement = {
                ...element,
                selected: false,
              };
              this.items.push(newElement);
            });

            value.forEach((element) => {
              var fieldNameRemove = this.items.find(
                (x) => x.FieldName == element
              );

              var iconSettingsToken = list.indexOf(fieldNameRemove.FieldName);

              if (iconSettingsToken != -1) {
                var iconStatus = list.substring(
                  iconSettingsToken - 1,
                  iconSettingsToken
                );
                var iconParam = {
                  color: null,
                  name: null,
                };

                if (iconStatus == "-") {
                  iconParam.color = "red";
                  iconParam.name = "remove";
                } else if (iconStatus == "+") {
                  iconParam.color = "green";
                  iconParam.name = "add";
                } else {
                  iconParam.color = "";
                  iconParam.name = "";
                }
              }

              fieldNameRemove.selected = true;
              var resultRemove = {
                iconColor: iconParam.color,
                iconName: iconParam.name,
                text: fieldNameRemove.FieldName,
                value: fieldNameRemove.FieldID,
              };
              this.resultList.push(resultRemove);
            });

            this.dialog = true;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getList() {
      this.$http
        .post(
          auth.API_URL + "api/AccountingIntegrations/IntegrationFieldList",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            response.body.forEach((element) => {
              var newElement = {
                ...element,
                selected: false,
              };
              this.items.push(newElement);
            });

            this.dialog = true;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-IntegrationTemplateLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
  },
  components: {
    loadingcomp,
  },
};
</script>

<style scoped>
.rounded-corner {
  border-start-end-radius: 20px;
  border-end-start-radius: 20px;
}
</style>
